import type { ReactNode } from "react";

export function Shell({ header, children }: { header?: ReactNode; children: ReactNode }) {
  return (
    <div
      className="mx-auto flex w-full max-w-[560px] flex-col bg-tgbg text-tgtext"
      style={{ height: "var(--tg-viewport-stable-height, 100vh)", minHeight: "100%" }}
    >
      {header}
      {children}
    </div>
  );
}

export function Header({ left, title, right }: { left: ReactNode; title: string; right: ReactNode }) {
  return (
    <header className="flex items-center justify-between px-4 pb-2 pt-[calc(var(--tg-content-safe-area-inset-top,0px)+10px)]">
      <div className="text-xs text-tghint">{left}</div>
      <div className="text-lg font-extrabold tracking-[0.2em]">{title}</div>
      <div className="text-xs text-tghint">{right}</div>
    </header>
  );
}

export function Centered({ children }: { children: ReactNode }) {
  return <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center">{children}</div>;
}
